'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = useNamedRoutes;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PatternUtils = require('react-router/lib/PatternUtils');

var _RouteUtils = require('react-router/lib/RouteUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makePaths(paths, route, basePath) {
  var path = route.path;
  var name = route.name;
  var indexRoute = route.indexRoute;
  var childRoutes = route.childRoutes;


  var fullPath = void 0;
  if (!path) {
    fullPath = basePath;
  } else if (path[0] === '/') {
    // TODO: This is getting deprecated.
    fullPath = path;
  } else if (basePath[basePath.length - 1] === '/') {
    fullPath = '' + basePath + path;
  } else {
    fullPath = basePath + '/' + path;
  }

  if (name) {
    /* eslint-disable no-param-reassign */
    paths[name] = fullPath;
    /* eslint-enable no-param-reassign */
  }

  if (indexRoute) {
    makePaths(paths, indexRoute, fullPath);
  }
  if (childRoutes) {
    childRoutes.forEach(function (childRoute) {
      return makePaths(paths, childRoute, fullPath);
    });
  }
}

function useNamedRoutes(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);

    var routes = options.routes;

    var paths = {};
    (0, _RouteUtils.createRoutes)(routes).forEach(function (route) {
      return makePaths(paths, route, '/');
    });

    function resolveLocation(location) {
      var name = void 0;
      if (typeof location === 'string') {
        if (location[0] !== '/') {
          name = location;
        }
      } else {
        name = location.name;
      }
      if (!name) {
        return location;
      }

      var path = paths[name];
      !path ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'Unknown route: %s', name) : (0, _invariant2.default)(false) : void 0;

      return _extends({}, location, {
        pathname: (0, _PatternUtils.formatPattern)(path, location.params)
      });
    }

    function push(location) {
      history.push(resolveLocation(location));
    }

    function replace(location) {
      history.replace(resolveLocation(location));
    }

    function createPath(location) {
      return history.createPath(resolveLocation(location));
    }

    function createHref(location) {
      return history.createHref(resolveLocation(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return history.createLocation.apply(history, [resolveLocation(location)].concat(args));
    }

    return _extends({}, history, {
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
}
module.exports = exports['default'];